





export default {
  name: 'SidebarMenu',
};
